import { useState } from "react";

import { useCall } from "../state/CallProvider";
import { IconBot } from "./icons";

export function LoginScreen() {
  const { state, login } = useCall();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const busy = state.auth.status === "loggingIn";

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!busy) void login(username, password);
  };

  return (
    <form className="lg" onSubmit={submit}>
      <span className="lg-logo"><IconBot size={26} /></span>
      <div className="lg-title">Metafore CTI</div>
      <div className="lg-sub">Sign in to take calls</div>

      <label className="lg-field">
        <span>Agent username</span>
        <input value={username} onChange={(e) => setUsername(e.target.value)}
          placeholder="e.g. dev-a1" autoFocus autoComplete="username" />
      </label>
      <label className="lg-field">
        <span>Password</span>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••" autoComplete="current-password" />
      </label>

      {state.auth.error && <div className="lg-err">{state.auth.error}</div>}

      <button className="lg-btn" type="submit" disabled={busy}>
        {busy ? "Signing in…" : "Sign in"}
      </button>
      <div className="lg-foot">Voice · secured by your workspace</div>
    </form>
  );
}
